<div class="NewFlightInfoIropsView-heads">
    <div class="NewFlightInfoIropsView-dateFlight">
        <div class="fs-24px fw-regular lh-30px text-am-white">
            <span class="opacity-70">
                {{ "srIrops.dateFlight" | translate }}
            </span>
        </div>
        <div>
            <span
                class="NewFlightInfoIropsView-detail fs-32px fw-medium-x lh-42px text-am-white"
                [ngClass]="{'opacity-75': statusIrops == 'Cancelled'}"
            >
                <span *ngIf="!segCancel">{{ affectedDepartureDateTime | localizedDate:'dd MMM' | titlecase }}</span>
                <span *ngIf="segCancel">{{segCancel?.departureDateTime | localizedDate:'dd MMM' | titlecase }}</span>
            </span>
        </div>
    </div>
    <div class="NewFlightInfoIropsView-separatorLine"></div>
    <div class="NewFlightInfoIropsView-flightNumber">
        <div class="fs-24px fw-regular lh-30px text-am-white">
            <span class="opacity-70">
                {{ "srIrops.vuelo" | translate }}
            </span>
        </div>
        <div class="NewFlightInfoIropsView-detail fs-32px fw-medium-x lh-42px text-am-white">
            <span [ngClass]="{'opacity-75': statusIrops == 'Cancelled'}">
                {{ flightNumber }}
            </span>
        </div>
    </div>
    <div class="NewFlightInfoIropsView-separatorLine"></div>
    <div class="NewFlightInfoIropsView-flightNumber">
        <div class="fs-24px fw-regular lh-30px text-am-white">
            <span class="opacity-70">
                {{ "noticeClose.gate" | translate }}
            </span>
        </div>
        <div class="NewFlightInfoIropsView-detail fs-32px fw-medium-x lh-42px text-am-white">
            <span [ngClass]="{'opacity-75': statusIrops == 'Cancelled'}">
                {{ gate.length > 0 ? gate : 'NA' }}
            </span>
        </div>
    </div>
    <div class="NewFlightInfoIropsView-separatorLine" *ngIf="statusIrops != 'Cancelled'"></div>
    <div class="NewFlightInfoIropsView-flightNumber" *ngIf="statusIrops != 'Cancelled'">
        <div class="fs-24px fw-regular lh-30px text-am-white">
            <span class="opacity-70">
                {{ "Boarding" | translate }}
            </span>
        </div>
        <div class="NewFlightInfoIropsView-detail fs-32px fw-medium-x lh-42px">
            <span [ngClass]="{
                    'text-am-yellow-rebrand-irops': statusIrops == 'Delayed',
                    'text-am-green': statusIrops == 'Early'
                }"
            >
                {{ boardingTime | date:'HH:mm' }}
            </span>
        </div>
    </div>
    <div class="NewFlightInfoIropsView-separatorLine"></div>
    <div class="NewFlightInfoIropsView-hourDeparture">
        <div class="fs-24px fw-regular lh-30px text-am-white">
            <span class="opacity-70">
                {{ "srIrops.departure" | translate: { departure: '' } }}
            </span>
        </div>
        <div class="NewFlightInfoIropsView-detail fs-32px fw-medium-x lh-42px text-am-yellow">
            <span [ngClass]="{
                    'text-line-through text-am-red-rebrand': statusIrops == 'Cancelled',
                    'text-am-yellow-rebrand-irops': statusIrops == 'Delayed',
                    'text-am-green': statusIrops == 'Early'
                }"
            >
                {{ timeAfected.departureTime }}
            </span>
        </div>
    </div>
    <div class="NewFlightInfoIropsView-separatorLine" *ngIf="statusIrops == 'Cancelled'"></div>
    <div class="NewFlightInfoIropsView-hourArrival" *ngIf="statusIrops == 'Cancelled'">
        <div class="fs-24px fw-regular lh-30px text-am-white">
            <span class="opacity-70">
                {{ "srIrops.arrival" | translate: { arrival: '' } }}
            </span>
        </div>
        <div class="NewFlightInfoIropsView-detail fs-32px fw-medium-x lh-42px text-am-yellow-rebrand-irops">
            <span [ngClass]="{
                    'text-line-through text-am-red-rebrand': statusIrops == 'Cancelled'
                }"
            >
                {{ timeAfected.arrivalTime }}
            </span>
        </div>
    </div>
</div>